import React, { useState, useRef, useEffect } from "react"

import RcmpLink from "../../../components_v2/atoms/Link"
import useClickOutside from "../../../hooks/useClickOutside"
import styles from "./index.module.scss"

function RcmpFloatingMenu(props) {
  const { children, className, aOptions, elFooter, fnOnChangeIsOpen } = props

  const [bIsMenuOpen, fnSetBIsMenuOpen] = useState(false)
  const [bOnAfterClose, fnSetBOnAfterClose] = useState(false)

  useEffect(() => {
    fnOnChangeIsOpen?.(bIsMenuOpen)
  }, [bIsMenuOpen])

  const elConfigMenu = useRef(null)

  const fnHandleClickOutside = () => {
    if (bIsMenuOpen) fnSetBOnAfterClose(true)
  }

  useClickOutside(elConfigMenu, fnHandleClickOutside)

  const cClass = `${styles.floatingMenuOptions} ${bOnAfterClose ? styles.close : ""} ${className ? className : ""}`

  const fnHandleToogleMenu = () => {
    if (!bIsMenuOpen) {
      fnSetBIsMenuOpen(true)
      return
    }

    fnSetBOnAfterClose(true)
  }

  const fnHandleAfterOnClose = () => {
    if (bOnAfterClose) {
      fnSetBIsMenuOpen(false)
      fnSetBOnAfterClose(false)
    }
  }

  return (
    <div ref={elConfigMenu} style={{ position: "relative" }}>
      <div onClick={fnHandleToogleMenu}>{children}</div>
      {(bIsMenuOpen || bOnAfterClose) && (
        <div className={cClass} onAnimationEnd={fnHandleAfterOnClose}>
          {aOptions?.map((oOption, nIndex) => {
            const cKey = `floating-menu-option-${nIndex}`
            if (oOption?.path) {
              const { path, name, icon, ...oRestOption } = oOption
              return (
                <RcmpLink key={cKey} to={path} {...oRestOption}>
                  {icon && <span className={styles.icon}>{icon}</span>}
                  {name}
                </RcmpLink>
              )
            }

            const { icon, name, ...oRestOption } = oOption
            return (
              <div key={cKey} {...oRestOption}>
                {icon && <span className={styles.icon}>{icon}</span>}
                {name}
              </div>
            )
          })}
          {elFooter && <div className={styles.footerVersion}>{elFooter}</div>}
        </div>
      )}
    </div>
  )
}

export default RcmpFloatingMenu
